// Import action types related to video inner data
import {
  VIDEOINNER_FETCH_DATA_SUCCESS,
  VIDEOINNER_HAVE_ERROR,
  VIDEOINNER_ARE_LOADING,
} from "../actionType";

// Define the initial state for the VideoInner reducer
const initialState = {
  data: [], // Initialize data as an empty array
  loading: true, // Set loading to true initially
  error: [], // Initialize error as an empty array
};

// Reducer function to handle video inner data-related actions and update state accordingly
export function VideoInnerReducer(state = initialState, action) {
  switch (action.type) {
    // Handle error case when fetching video inner data
    case VIDEOINNER_HAVE_ERROR:
      return {
        ...state,
        error: action.hasError, // Update the error state with the error from the action
        loading: false, // Set loading to false since the request is complete
      };

    // Handle loading state when video inner data is being fetched
    case VIDEOINNER_ARE_LOADING:
      return {
        ...state,
        loading: action.isLoading, // Update the loading state with the loading status from the action
      };

    // Handle success case when video inner data is successfully fetched
    case VIDEOINNER_FETCH_DATA_SUCCESS:
      return {
        ...state,
        data: action.VideoInner, // Update the data state with the fetched video inner data
        loading: false, // Set loading to false since the request is complete
        error: [], // Clear any previous errors (assuming the success case means no error)
      };

    // Return the current state by default if action type is not recognized
    default:
      return state;
  }
}
